import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';


function ScheduledChip() {

    const { t } = useTranslation();

    return (
        <Chip
            icon={<BuildCircleOutlinedIcon />}
            label={t('chip.scheduled')}
            variant="outlined"
            color="warning"
            size="medium"
            sx={{ width: '100%' }}
        />
    );
};

export default ScheduledChip;